import { ArrowRight } from "lucide-react";

const GetStarted = () => {
  return (
    <section className="w-full bg-gradient-to-b from-gray-50 to-white flex flex-col">
      {/* Main Hero Content */}
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16 xl:py-12">
        <div className="max-w-3xl lg:max-w-4xl mx-auto text-center">
          {/* Main Heading */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Manage. Track. Grow
          </h1>

          {/* Subheading */}
          <div className="max-w-xl sm:max-w-2xl mx-auto mb-6 sm:mb-8">
            <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-gray-600 leading-relaxed mb-1 sm:mb-2">
              Ready to streamline your fleet operations and increase your
              profits?
            </p>
            <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-gray-600 leading-relaxed">
              Sign up now and take your fleet management to the next level.
            </p>
          </div>

          {/* CTA Button */}
          <button className="inline-flex items-center gap-2 bg-[#7A990E] hover:bg-primary/80 text-white font-semibold px-4 py-2 sm:px-6 sm:py-3 rounded-lg transition-all duration-200 hover:shadow-lg transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 text-sm sm:text-base">
            Get started
            <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4" />
          </button>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="mt-6 sm:mt-8 lg:mt-10 relative h-[15vh] sm:h-[20vh] lg:h-[25vh] xl:h-[30vh] w-full overflow-hidden">
        {/* Large Circle */}
        <div className="absolute right-[200px] sm:right-[250px] lg:right-[300px] top-1 w-[60vw] sm:w-[65vw] lg:w-[70vw] xl:w-[72vw] h-[8000px] sm:h-[12000px] lg:h-[16000px] xl:h-[20000px] rounded-full border border-[#BCBCBC] shadow-lg sm:shadow-xl lg:shadow-2xl shadow-[#7A990E]"></div>

        {/* Medium Circle */}
        <div className="absolute right-[320px] sm:right-[380px] lg:right-[420px] xl:right-[470px] top-8 sm:top-12 lg:top-16 xl:top-20 w-[45vw] sm:w-[50vw] lg:w-[52vw] xl:w-[55vw] h-[8000px] sm:h-[12000px] lg:h-[16000px] xl:h-[20000px] rounded-full border border-[#BCBCBC]"></div>

        {/* Small Circle */}
        <div className="absolute right-[450px] sm:right-[520px] lg:right-[580px] xl:right-[650px] top-16 sm:top-24 lg:top-32 xl:top-40 w-[30vw] sm:w-[32vw] lg:w-[33vw] xl:w-[35vw] h-[8000px] sm:h-[12000px] lg:h-[16000px] xl:h-[20000px] rounded-full border border-[#BCBCBC]"></div>
      </div>
    </section>
  );
};

export default GetStarted;
